


export type DossierType = 'Hr' | 'Project';

export const DossierType = {
    Hr: 'Hr' as DossierType,
    Project: 'Project' as DossierType
};

